/* One-time tool offer on the book buy box (snippets/ec-tool-offer.liquid). Built Sep 28 2026.

   - Swipe row of bar tools at the drawer's 20% add-on price. One tool can be picked.
   - With a tool picked, Add to cart reads "ADD BOTH TO CART" (no price on the button since Oct 15 2026: the line under it shows both prices), and one
     tap puts the tool in the cart first, then lets the theme's own ProductForm add the book,
     so the cart drawer opens once, showing both.
   - The row hides itself when its 20% price would not survive checkout: a bar tool already in
     the cart, or 2+ copies of a paperback while the copy discounts do not combine with it.
   - Tracking: the tool's cart line carries the hidden property _source, and Clarity gets
     tool_offer_pick and tool_offer_added. */
(function () {
  'use strict';

  function num(v) { return parseInt(v, 10) || 0; }

  function track(a, b, c) {
    try { if (typeof window.clarity === 'function') { if (c === undefined) window.clarity(a, b); else window.clarity(a, b, c); } } catch (e) {}
  }

  function money(c) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(c, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (c / 100).toFixed(2);
  }

  function init(box) {
    if (!box || box.__ector) return;
    var root = box.closest('[data-ecofr]');
    var form = box.closest('form');
    if (!root || !form) return;
    box.__ector = true;

    var atc = form.querySelector('.ecofr-atc');
    var labelEl = form.querySelector('[data-eco-label]');
    var priceEl = form.querySelector('[data-eco-price]');
    var qtyInput = form.querySelector('[data-eco-qty]');
    var note = root.querySelector('[data-ector-note]');
    var rail = box.querySelector('[data-ector-rail]');
    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-ector-card]'));
    var prev = box.querySelector('[data-ector-prev]');
    var next = box.querySelector('[data-ector-next]');
    var dotsBox = box.querySelector('[data-ector-dots]');
    if (!atc || !priceEl || !rail || !cards.length) return;

    var D = box.dataset;
    var eb = num(D.eb), pb = num(D.pb), q2 = num(D.q2), q3 = num(D.q3), q2was = num(D.q2was), q3was = num(D.q3was);
    var pbVid = num(D.pbVid), t2q = num(D.t2q) || 2, shipMin = num(D.shipMin);
    var multiOk = D.multiOk === 'true', isUS = D.us === 'true';
    var barIds = (D.barIds || '').split(',').filter(Boolean).map(Number);
    var bookIds = (D.bookIds || '').split(',').filter(Boolean).map(Number);
    var cartBar = D.cartBar === 'true', cartPb = num(D.cartPb), cartMulti = D.cartMulti === 'true';
    var baseLabel = labelEl ? labelEl.textContent : '';
    var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var sel = null, touched = false;

    function fmt() { return document.documentElement.getAttribute('data-ecbk-fmt') === 'paperback' ? 'paperback' : 'ebook'; }
    function qty() { return fmt() === 'paperback' && qtyInput ? (num(qtyInput.value) || 1) : 1; }
    function bookCents() { if (fmt() === 'ebook') return eb; var q = qty(); return q >= 3 ? q3 : (q === 2 ? q2 : pb); }
    function bookWas() { if (fmt() === 'ebook') return eb; var q = qty(); return q >= 3 ? q3was : (q === 2 ? q2was : pb); }

    function blocked() {
      if (cartBar) return true;
      if (multiOk) return false;
      if (cartMulti) return true;
      return cartPb + (fmt() === 'paperback' ? qty() : 0) >= t2q;
    }

    /* the price the buy box shows on its own, read from the same attributes its script uses */
    function ownPrice() {
      if (fmt() === 'paperback') {
        var ch = root.querySelector('[data-eco-chip].on');
        if (ch && qtyInput) return ch.getAttribute('data-total');
        var pc = root.querySelector('[data-eco-card][data-format="paperback"]');
        if (pc) return pc.getAttribute('data-price');
      }
      var c = root.querySelector('[data-eco-card].on');
      return c ? c.getAttribute('data-price') : priceEl.textContent;
    }

    function setNote(parts) {
      if (!note) return;
      note.textContent = '';
      parts.forEach(function (p) {
        if (p.b) { var b = document.createElement('b'); b.textContent = p.b; note.appendChild(b); }
        else note.appendChild(document.createTextNode(p));
      });
      note.hidden = !parts.length;
    }

    function render() {
      var hide = blocked();
      box.hidden = hide;
      if (hide) sel = null;

      var paper = fmt() === 'paperback';
      var gap = shipMin - (paper ? bookCents() : 0);
      cards.forEach(function (c) {
        var on = c === sel;
        c.classList.toggle('on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        var add = c.querySelector('[data-ector-add]');
        if (add) add.textContent = on ? (D.added || '✓ Added') : (D.add || '+ Add');
        var sh = c.querySelector('[data-ector-ship]');
        if (sh) sh.hidden = !(isUS && paper && gap > 0 && num(c.getAttribute('data-now')) >= gap);
      });

      if (sel) {
        var multi = paper && qty() > 1;
        var now = num(sel.getAttribute('data-now')), off = num(sel.getAttribute('data-off'));
        var name = sel.getAttribute('data-name');
        if (labelEl) labelEl.textContent = multi ? (D.atcAll || 'ADD ALL TO CART') : (D.atcBoth || 'ADD BOTH TO CART');
        priceEl.textContent = money(bookCents() + now);
        touched = true;
        if (!paper) setNote(['E-book ', { b: money(bookCents()) }, ' + ' + name + ' ', { b: money(now) }, '. You save ' + money(off) + ' on the tool.']);
        else if (multi) setNote([qty() + ' paperbacks ', { b: money(bookCents()) }, ' + ' + name + ' ', { b: money(now) }, '. You save ' + money(bookWas() - bookCents() + off) + ' in total.']);
        else if (isUS && bookCents() + now >= shipMin) setNote(['Paperback ', { b: money(bookCents()) }, ' + ' + name + ' ', { b: money(now) }, '. You save ' + money(off) + ' and US shipping is free.']);
        else setNote(['Paperback ', { b: money(bookCents()) }, ' + ' + name + ' ', { b: money(now) }, '. You save ' + money(off) + ' on the tool.']);
      } else if (touched) {
        if (labelEl) labelEl.textContent = baseLabel;
        priceEl.textContent = ownPrice();
        touched = false;
        setNote([]);
      }
      updateNav();
    }

    /* ---- swipe row: arrows, dots, mouse drag (phones swipe natively) ---- */
    var dots = cards.map(function (c, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Tool ' + (i + 1) + ' of ' + cards.length);
      d.addEventListener('click', function () { rail.scrollTo({ left: i * step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (dotsBox) dotsBox.appendChild(d);
      return d;
    });
    function step() {
      var cs = window.getComputedStyle(rail);
      return cards[0].getBoundingClientRect().width + (parseFloat(cs.columnGap || cs.gap) || 10);
    }
    function updateNav() {
      if (box.hidden) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      var s = step(), idx = s > 0 ? Math.round(rail.scrollLeft / s) : 0;
      if (max > 0 && rail.scrollLeft >= max) idx = cards.length - 1;
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; updateNav(); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    window.addEventListener('resize', updateNav);

    var drag = null, suppress = false;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: rail.scrollLeft, on: false, id: e.pointerId };
    });
    rail.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.on && Math.abs(dx) > 5) {
        drag.on = true;
        rail.classList.add('is-drag');
        try { rail.setPointerCapture(drag.id); } catch (err) {}
      }
      if (drag.on) rail.scrollLeft = drag.left - dx;
    });
    function endDrag() {
      if (!drag) return;
      if (drag.on) {
        suppress = true;
        setTimeout(function () { suppress = false; }, 0);
        rail.classList.remove('is-drag');
      }
      drag = null;
    }
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('lostpointercapture', endDrag);

    /* ---- picking a tool ---- */
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        if (suppress) return;
        sel = sel === c ? null : c;
        if (sel) {
          track('event', 'tool_offer_pick');
          track('set', 'tool_offer_pick', c.getAttribute('data-name'));
        }
        render();
        if (!reduce && atc.animate) {
          atc.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'ease-out' });
        }
      });
    });

    /* the buy box's own cards and chips rewrite the button price; re-apply ours after them */
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-eco-card],[data-eco-chip]')) setTimeout(render, 0);
    });
    window.addEventListener('ecbk:format', function () { setTimeout(render, 0); });

    /* ---- add to cart: tool first, then the theme's normal add for the book ---- */
    root.addEventListener('submit', function (ev) {
      if (ev.target !== form) return;
      if (form.__ectorPass) { form.__ectorPass = false; return; }
      if (!sel || box.hidden) return;
      ev.preventDefault();
      ev.stopPropagation();
      var picked = sel;
      var submitter = ev.submitter && ev.submitter.form === form ? ev.submitter : atc;
      atc.classList.add('ector-busy');
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: num(picked.getAttribute('data-vid')), quantity: 1, properties: { _source: D.source || 'book page tool offer' } }] })
      }).then(function (r) {
        if (r.ok) {
          track('event', 'tool_offer_added');
          track('set', 'tool_offer_added', picked.getAttribute('data-name'));
        }
      }).catch(function () {}).then(function () {
        atc.classList.remove('ector-busy');
        form.__ectorPass = true;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitter);
        } else {
          var go = form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          if (go) form.submit();
        }
      });
    }, true);

    /* ---- keep in step with the cart ---- */
    var syncing = null;
    function syncCart() {
      clearTimeout(syncing);
      syncing = setTimeout(function () {
        fetch(cartRoot + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var bar = false, pbq = 0, multi = false;
            (cart.items || []).forEach(function (it) {
              if (barIds.indexOf(it.product_id) > -1) bar = true;
              if (it.variant_id === pbVid) pbq += it.quantity;
              else if (it.requires_shipping && it.quantity >= t2q && bookIds.indexOf(it.product_id) > -1) multi = true;
            });
            cartBar = bar; cartPb = pbq; cartMulti = multi;
            render();
          })
          .catch(function () {});
      }, 250);
    }
    document.addEventListener('cart:updated', syncCart);
    function hookPubsub() {
      if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, syncCart);
        return true;
      }
      return false;
    }
    if (!hookPubsub()) document.addEventListener('DOMContentLoaded', hookPubsub);
    window.addEventListener('pageshow', function (e) { if (e.persisted) syncCart(); });

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ector]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
